// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mes-documents {
  padding: 2rem;
  max-width: 120rem;
  margin: 0 auto;
}

.mes-documents h1 {
  margin-bottom: 3rem;
}

/* .document-section {
  background-color: #FFFDFC;
  padding: 2rem;
  border-radius: 0.8rem;
  margin-bottom: 2rem;
  position: relative;
} */

/* .document-section h2 {
  color: #2C3948;
  margin-bottom: 1rem;
} */

.document-section .documents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.document-card {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background-color: rgba(215, 217, 217, 0.20);
  border-radius: 10px;
}

.document-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.document-content > svg {
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-name {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.4rem;
  color: #2C3948;
}

.document-actions {
  display: flex;
  gap: 1rem;
}

.document-actions button {
  white-space: nowrap;
}

/* .section-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
} */

.section-header h2 {
  font-size: 1.8rem;
  font-weight: 600;
  color: #2C3948;
}

.view-more-icon {
  width: 1.6rem;
  height: 1.6rem;
  color: #2C3948;
  cursor: pointer;
}

.view-more-icon:hover {
  color: #1A2634;
}

.add-document-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/composants/MesDocuments/MesDocuments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;GAMG;;AAEH;;;GAGG;;AAEH;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;GAKG;;AAEH;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".mes-documents {\r\n  padding: 2rem;\r\n  max-width: 120rem;\r\n  margin: 0 auto;\r\n}\r\n\r\n.mes-documents h1 {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n/* .document-section {\r\n  background-color: #FFFDFC;\r\n  padding: 2rem;\r\n  border-radius: 0.8rem;\r\n  margin-bottom: 2rem;\r\n  position: relative;\r\n} */\r\n\r\n/* .document-section h2 {\r\n  color: #2C3948;\r\n  margin-bottom: 1rem;\r\n} */\r\n\r\n.document-section .documents-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));\r\n  gap: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.document-card {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1.5rem;\r\n  background-color: rgba(215, 217, 217, 0.20);\r\n  border-radius: 10px;\r\n}\r\n\r\n.document-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.document-content > svg {\r\n  width: 4rem;\r\n  height: 4rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.document-name {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  font-size: 1.4rem;\r\n  color: #2C3948;\r\n}\r\n\r\n.document-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.document-actions button {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* .section-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n} */\r\n\r\n.section-header h2 {\r\n  font-size: 1.8rem;\r\n  font-weight: 600;\r\n  color: #2C3948;\r\n}\r\n\r\n.view-more-icon {\r\n  width: 1.6rem;\r\n  height: 1.6rem;\r\n  color: #2C3948;\r\n  cursor: pointer;\r\n}\r\n\r\n.view-more-icon:hover {\r\n  color: #1A2634;\r\n}\r\n\r\n.add-document-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 2rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
